import React from 'react';

import Form from 'src/components/Form/Form.jsx';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';

class ChangeMarketForm extends Form {

    renderForm(): React.ReactElement {
        const markets: Array<{letter: string, list: Array<MarketModel>}> = this.props.markets;
        const marketsList: Array<MarketModel> = [];

        for (const marketGroup of markets) {
            for (const market of marketGroup.list) {
                marketsList.push(market);
            }
        }

        marketsList.sort((a, b) => {
            if (a.displayOrder > b.displayOrder) {
                return 1;
            }

            if (a.displayOrder < b.displayOrder) {
                return -1;
            }

            if (a.name > b.name) {
                return 1;
            }

            if (a.name < b.name) {
                return -1;
            }

            return 0;
        });

        const elements = marketsList.map((market) => {
            return <option key={ market.id } value={ market.id }>{ market.name }</option>;
        });

        return (
            this.getField(
                <select
                    //@ts-expect-error
                    label='Market'
                    { ...this.getFieldParameters('market') }>
                    { elements }
                </select>
            )
        );
    }
}

export default ChangeMarketForm;
